import React from 'react';
export const Benefits = () => {
  return <section className="text-lg md:text-xl text-gray-800 mb-12 leading-relaxed space-y-6" data-id="element-17" data-mp="2q75slllr9nd5">
      <h2 className="font-bold text-2xl md:text-3xl mt-12 mb-6 text-gray-900" data-id="element-18" data-mp="9bnyjr1kv3fy">
        What This Means For You
      </h2>

      <p data-id="element-19" data-mp="4i2xtr8lnvd2">
        Switching to{' '}
        <a href="#offer" className="text-blue-700 underline font-bold" data-id="element-20" data-mp="3vr8m1mo0cv1i">
          VelaSleep
        </a>{' '}
        isn't just about a new pillow; it's about changing how your mornings
        feel.
      </p>

      <ul className="space-y-4 list-disc pl-6" data-id="element-21" data-mp="3mpsmk9yqedc2">
        <li data-id="element-22" data-mp="3ms52khkxidmh">
          <strong data-id="element-23" data-mp="3hqxyotlwpyl3">Wake Up Feeling More Refreshed:</strong> Instead of starting
          the day focused on discomfort.
        </li>
        <li data-id="element-24" data-mp="3cso3ij06mxzh">
          <strong data-id="element-25" data-mp="3ct65zxdfu8fu">Stop Searching For The Perfect Position:</strong> Consistent
          support helps reduce tossing and turning.
        </li>
        <li data-id="element-26" data-mp="1fx8czupx3mdk">
          <strong data-id="element-27" data-mp="1b0hwx7e44qs5">Enjoy More Comfortable Sleep:</strong> Pressure-relieving
          design adapts to your body.
        </li>
        <li data-id="element-28" data-mp="2qy5ssvdbuj2">
          <strong data-id="element-29" data-mp="2qeonedjla63">Support Better Sleep Habits:</strong> Comfort makes it easier
          to settle in and stay asleep.
        </li>
        <li data-id="element-30" data-mp="6qosolhrxqib">
          <strong data-id="element-31" data-mp="6qgij1d1czat">Feel More Like Yourself Again:</strong> Because mornings
          shouldn't begin with frustration.
        </li>
      </ul>
    </section>;
};